export default __webpack_public_path__ + "static/media/no-image-found.16383d75.jpg";